import React, { useRef, useEffect } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value?: string;
  format?: 'CODE128' | 'EAN13' | 'UPC' | string;
  width?: number;
  height?: number;
  displayValue?: boolean;
  margin?: number;
}

/**
 * React component wrapping JsBarcode
 */
export default function Barcode({
  value,
  format = 'CODE128',
  width = 2,
  height = 100,
  displayValue = true,
  margin = 10,
}: BarcodeProps) {
  // Use a RefObject with correct SVG element type
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current && value) {
      JsBarcode(svgRef.current, value, {
        format,
        width,
        height,
        displayValue,
        margin,
      });
    }
  }, [value, format, width, height, displayValue, margin]);

  return (
    // svgRef is a RefObject<SVGSVGElement>, compatible with SVG ref
    <svg ref={svgRef} />
  );
}